import * as $ from 'jquery';
import "./framework";

$(document).ready(function () {

    var choiceAge = $('input[name=choiceAge]');
    // var choiceLastTherapyEnded = $('input[name=choice24]');

    function conditionRedirect(){
        var link;

        if(choiceAge.filter(':checked').val() == "yes" || choiceAge.filter(':checked').val() == "maybe") {
            $('#dangerParagraph').removeClass('info__incomplete');
        }

        // if(choiceLastTherapyEnded.filter(':checked').val() == "no") {
        //     $('#dangerParagraphTemporary').removeClass('info__incomplete');
        // }

        if(choiceAge.filter(':checked').val() == "no") {
            $('#dangerParagraph').addClass('info__incomplete');
            if ($('#submitLinkTherapy').hasClass('slide__link--enabled')) {
                $('#submitLinkTherapy').addClass('slide__link--disabled').removeClass('slide__link--enabled');
            }
        }

        // if(choiceLastTherapyEnded.filter(':checked').val() == "yes") {
        //     $('#dangerParagraphTemporary').addClass('info__incomplete');
        //     if ($('#submitLinkTherapy').hasClass('slide__link--enabled')) {
        //         $('#submitLinkTherapy').addClass('slide__link--disabled').removeClass('slide__link--enabled');
        //     }
        // }

        if (choiceAge.filter(':checked').val() == "yes") {
            $('#dangerParagraphTemporary').removeClass('info__incomplete');
            $('#dangerParagraph').removeClass('info__incomplete');
            if ($('#submitLinkTherapy').hasClass('slide__link--disabled')) {
                $('#submitLinkTherapy').addClass('slide__link--enabled').removeClass('slide__link--disabled');
            }
            link = '/sprechstunde-buchen/krankenkassen';
        } else if(choiceAge.filter(':checked').val() == "maybe") {
            $('#dangerParagraphTemporary').removeClass('info__incomplete');
            $('#dangerParagraph').removeClass('info__incomplete');
            if ($('#submitLinkTherapy').hasClass('slide__link--disabled')) {
                $('#submitLinkTherapy').addClass('slide__link--enabled').removeClass('slide__link--disabled');
                link = '/sprechstunde-buchen/beratung-15-17';
            }
        }

        $('#therapyForm').attr('action', link);
    }

    // choiceLastTherapyEnded.on('click', function () {
    //     $('label[for=first]').removeClass('selectedColor');
    //     $('label[for=second]').removeClass('selectedColor');
    //     conditionRedirect();
    //     $(this).closest('label').addClass('selectedColor');
    // });

    choiceAge.on('click', function () {
        $('label[for=third]').removeClass('selectedColor');
        $('label[for=thirdpointtwo]').removeClass('selectedColor');
        $('label[for=forth]').removeClass('selectedColor');
        conditionRedirect();
        $(this).closest('label').addClass('selectedColor');
    });


    $('#submitLinkTherapy').on('click', function (e) {
        e.preventDefault();
        // Double check age
        if (choiceAge.filter(':checked').val() == "no"){
            $('#dangerParagraph').addClass('info__incomplete');
            $('#therapyForm').attr('action', '');
        }
        var value = $('#therapyForm').attr('action');
        if(value != '') {
            $('#therapyForm').submit();
        }
    });


    $("#searchInsurance").selectize({
        items: [''],
        create: false,
        placeholder: "Name der Krankenkasse ...",
        maxOptions: 300,
        closeAfterSelect: true,
        highlight: false,
        copyClassesToDropdown: true,
        onChange: function (val) {
            var data = this.options[val]; // <-- This is how to pull data-data from the original options
            var approved = data['approved'];
            var link = '/sprechstunde-buchen/email-krankenkasse?kuerzel=' + data['abbr'];

            $('.slide__link--disabled').addClass('slide__link--enabled').removeClass('slide__link--disabled');
            if (approved == true) {
                link = 'https://custom.bookingtime.com/kirinus/bookingmodule/location?insurance=' + data['abbr'];
            }
            $('.slide__link--enabled').attr('href', link);
            $('.selectize-input').addClass('selectedInsurance');

        }
    });
    $('.selectize-input').on('click', function () {
        $(this).removeClass('selectedInsurance');
    });

    $('html').keyup(function(e){
        if(e.keyCode == 8 || e.keyCode == 46 ) {
            $('.selectize-input input:first-child').attr('style', 'width: 100% !important');
            $('.selectize-input').removeClass('selectedInsurance');
        }
    });
    $('.selectize-input input:first-child').css('width', '100%');

    // Newsletter registration for date

    $('#slide__date input').on('change', function () {
        if (
            $('#info__datenschutz').is(':checked') &&
            $('#info__date').val() != '' &&
            $('#info__name').val() != '' &&
            $('#info__email').val() != ''
        ) {
            $('.slide__link--disabled').addClass('slide__link--enabled').removeClass('slide__link--disabled');
        } else {
            $('.slide__link--enabled').addClass('slide__link--disabled').removeClass('slide__link--enabled');
        }
    });

    $('#submitLink').on('click', function () {
        $('.info__incomplete').html('');

        if (!$('#info__datenschutz').is(':checked')) {
            $('.info__incomplete--privacy').html('Bitte bestätigen Sie die Datenschutzbestimmungen!');
        }

        if ($('#info__date').val() == '') {
            $('.info__incomplete--date').html('Bitte geben Sie ein gültiges Datum an!');
        }

        if ($('#info__name').val() == '') {
            $('.info__incomplete--name').html('Bitte geben Sie einen Namen an!');
        }

        var mail = $('#info__email').val();
        if (mail == '' || !isEmail(mail)) {
            $('.info__incomplete--email').html('Bitte geben Sie eine gültige E-Mail-Adresse an!');
        }

        if (
            $('#info__datenschutz').is(':checked') &&
            $('#info__date').val() != '' &&
            $('#info__name').val() != '' &&
            (mail != '' && isEmail(mail))
        ) {
            $('#dateForm').submit();
        }
    });


    // Newsletter registration for insurance

    $('#slide__insurance input').on('change', function () {
        if (
            $('#info__datenschutz').is(':checked') &&
            $('#info__name').val() != '' &&
            $('#info__email').val() != ''
        ) {
            $('.slide__link--disabled').addClass('slide__link--enabled').removeClass('slide__link--disabled');
        } else {
            $('.slide__link--enabled').addClass('slide__link--disabled').removeClass('slide__link--enabled');
        }
    });

    $('#submitLinkInsurance').on('click', function () {
        $('.info__incomplete').html('');
        if (!$('#info__datenschutz').is(':checked')) {
            $('.info__incomplete--privacy').html('Bitte bestätigen Sie die Datenschutzbestimmungen!');
        }

        if ($('#info__name').val() == '') {
            $('.info__incomplete--name').html('Bitte geben Sie einen Namen an!');
        }

        var mail = $('#info__email').val();
        if (mail == '' || !isEmail(mail)) {
            $('.info__incomplete--email').html('Bitte geben Sie eine gültige E-Mail-Adresse an!');
        }

        if (
            $('#info__datenschutz').is(':checked') &&
            $('#info__name').val() != '' &&
            (mail != '' && isEmail(mail))
        ) {
            $('#insuranceForm').submit();
        }
    });
    // Newsletter registration for call

    $('#slide__call input').on('change', function () {
        if (
            $('#info__datenschutz').is(':checked') &&
            $('#info__tel').val() != '' &&
            $('#info__name').val() != '' &&
            ($('#info__call--morning').is(':checked') ||
             $('#info__call--noon').is(':checked') ||
             $('#info__call--afternoon').is(':checked'))
        ) {
            $('.slide__link--disabled').addClass('slide__link--enabled').removeClass('slide__link--disabled');
        } else {
            $('.slide__link--enabled').addClass('slide__link--disabled').removeClass('slide__link--enabled');
        }
    });

    $('#slide__call select').on('change', function () {
        if ($(this).val() == 3) {
            $('#info__name').attr('placeholder', 'Ihr Vor- und Nachname');
            $("label[for='info__name']").html('Ihr Vor- und Nachname');
        } else {
            $('#info__name').attr('placeholder', 'Ihr Nachname');
            $("label[for='info__name']").html('Ihr Nachname');
        }
    });

    $('#submitLinkCall').on('click', function () {
        $('.info__incomplete').html('');
        if (!$('#info__datenschutz').is(':checked')) {
            $('.info__incomplete--privacy').html('Bitte bestätigen Sie die Datenschutzbestimmungen!');
        }

        if ($('#info__name').val() == '') {
            $('.info__incomplete--name').html('Bitte geben Sie einen Namen an!');
        }

        var tel = $('#info__tel').val();
        if (tel == '') {
            $('.info__incomplete--tel').html('Bitte geben Sie eine Rückrufnummer an!');
        }

        if (!$('#info__call--morning').is(':checked') &&
            !$('#info__call--noon').is(':checked') &&
            !$('#info__call--afternoon').is(':checked'))
        {
            $('.info__incomplete--call').html('Bitte geben Sie einen Rückrufzeitraum an!');
        }

        if (
            $('#info__datenschutz').is(':checked') &&
            $('#info__tel').val() != '' &&
            $('#info__name').val() != '' &&
            ($('#info__call--morning').is(':checked') ||
             $('#info__call--noon').is(':checked') ||
             $('#info__call--afternoon').is(':checked'))
        ) {
            $('#callForm').submit();
        }
    });

    // Newsletter registration for young call

    $('#slide__call--young input').on('change', function () {
        if (
            $('#info__datenschutz').is(':checked') &&
            $('#info__tel').val() != '' &&
            $('#info__name').val() != '' &&
            $('#info__birthdate').val() != '' &&
            ($('#info__call--morning').is(':checked') ||
             $('#info__call--noon').is(':checked') ||
             $('#info__call--afternoon').is(':checked'))
        ) {
            $('.slide__link--disabled').addClass('slide__link--enabled').removeClass('slide__link--disabled');
        } else {
            $('.slide__link--enabled').addClass('slide__link--disabled').removeClass('slide__link--enabled');
        }
    });

    $('#slide__call--young select').on('change', function () {
        if ($(this).val() == 3) {
            $('#info__name').attr('placeholder', 'Ihr Vor- und Nachname');
            $("label[for='info__name']").html('Ihr Vor- und Nachname');
        } else {
            $('#info__name').attr('placeholder', 'Ihr Nachname');
            $("label[for='info__name']").html('Ihr Nachname');
        }
    });

    $('#submitLinkCall').on('click', function () {
        $('.info__incomplete').html('');
        if (!$('#info__datenschutz').is(':checked')) {
            $('.info__incomplete--privacy').html('Bitte bestätigen Sie die Datenschutzbestimmungen!');
        }

        if ($('#info__name').val() == '') {
            $('.info__incomplete--name').html('Bitte geben Sie einen Namen an!');
        }

        var tel = $('#info__tel').val();
        if (tel == '') {
            $('.info__incomplete--tel').html('Bitte geben Sie eine Rückrufnummer an!');
        }
        var birth = $('#info__birthdate').val();
        if (birth == '') {
            $('.info__incomplete--birthdate').html('Bitte geben Sie Ihr Geburtsdatum an!');
        }

        var plz = $('#info__plz').val();
        if (plz == '') {
            $('.info__incomplete--plz').html('Bitte geben Sie eine valide PLZ an!');
        }

        if (!$('#info__call--morning').is(':checked') &&
            !$('#info__call--noon').is(':checked') &&
            !$('#info__call--afternoon').is(':checked'))
        {
            $('.info__incomplete--call').html('Bitte geben Sie einen Rückrufzeitraum an!');
        }

        if (
            $('#info__datenschutz').is(':checked') &&
            $('#info__tel').val() != '' &&
            $('#info__name').val() != '' &&
            $('#info__plz').val() != '' &&
            $('#info__birthdate').val() != '' &&
            ($('#info__call--morning').is(':checked') ||
             $('#info__call--noon').is(':checked') ||
             $('#info__call--afternoon').is(':checked'))
        ) {
            $('#callYoungForm').submit();
        }
    });

    function isEmail(email) {
        var EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return EmailRegex.test(email);
    }

    // Get footer to bottom for every viewport

    var bodyHeight = $("body").height();
    var vwptHeight = $(window).height();
    if (vwptHeight > bodyHeight) {
        $(".elementor-location-footer").css("position", "absolute").css("bottom", 0);
    }
});
